import { isStaging } from "./utils/utils";

/**
 * Determines the appropriate base URL for the design-stream API
 * based on whether we're running locally, staging, or production
 */
export function getSearchApiBaseUrl(): string {
    const isLocalhost =
        typeof window !== 'undefined' &&
        (window.location.hostname === 'localhost' ||
            window.location.hostname === '127.0.0.1' ||
            window.location.hostname.startsWith('192.168.') ||
            window.location.hostname.endsWith('.local'));

    const useStaging = isStaging();

    if (isLocalhost) {
        return 'http://localhost:8080';
    } else {
        if (useStaging) {
            // Stage / Daily
            return 'https://design-stream-backend-829457126264.us-central1.run.app';
        } else {
            // Production / Beta
            return 'https://design-stream-backend-709632310154.us-central1.run.app';
        }
    }
}
